import {
  Box,
  Button,
  Checkbox,
  Collapse,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  List,
  ListItem,
  Text,
  useDisclosure,
  Icon,
  Portal,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import { useEffect, useState, useRef } from "react";
import { FiChevronDown, FiChevronUp, FiSearch, FiX } from "react-icons/fi";

const ModalSelectManagers = observer((props) => {
  const { pageStore } = useStores();
  const { isOpen, onToggle, onClose } = useDisclosure();
  //const [searchTerm, setSearchTerm] = useState("");
  const [selectedManagers, setSelectedManagers] = useState([]);
  const dropdownRef = useRef(null);
  const shouldAutoSaveRef = useRef(false);
  const menuRef = useRef(null);

  useEffect(() => {
    pageStore.updateSelectedManagers([]);
  }, []);


  const filteredManagers = pageStore.all_managers.filter((manager) =>
    manager.fio.toLowerCase().includes(pageStore.searchTermManagers.toLowerCase())
  );

  const handleSelect = (managerFio) => {
    setSelectedManagers((prev) =>
      prev.includes(managerFio)
        ? prev.filter((fio) => fio !== managerFio)
        : [...prev, managerFio]
    );
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      shouldAutoSaveRef.current = true; // ⬅ помечаем, что нужно сохранить
      onClose(); // ⬅ просто закрываем
    }
  };

    useEffect(() => {
      const handleClickOutside = (e) => {
        const path = e.composedPath();

        const clickedInsideDropdown =
          path.includes(dropdownRef.current) ||
          path.includes(menuRef.current);

        if (!clickedInsideDropdown) {
          pageStore.updateSelectedManagers(selectedManagers);
          shouldAutoSaveRef.current = false;
          onClose();
        }
      };

      document.addEventListener("click", handleClickOutside);

      return () =>
        document.removeEventListener("click", handleClickOutside);
    }, [selectedManagers, onClose]);


    useEffect(() => {
      document.addEventListener("click", handleClickOutside);
      return () => document.removeEventListener("click", handleClickOutside);
    }, []);


    const handleSelectAll = () => {
      if (selectedManagers.length === filteredManagers.length) {
        setSelectedManagers([]);
      } else {
        setSelectedManagers(filteredManagers.map((manager) => manager.fio));
      }
    };

    const handleSave = () => {
      console.log(selectedManagers)
      pageStore.updateSelectedManagers(selectedManagers);
      onClose();
    };

    useEffect(() => {
      setSelectedManagers(pageStore.selected_managers ?? []);
    }, [pageStore.selected_managers]);

    const handleCencel = () => {
      setSelectedManagers(pageStore.selectedManagers);
      onClose();
    }
    const handleReset = () => {
      setSelectedManagers([]);
      pageStore.updateSelectedManagers([]);
      pageStore.setSearchTermManagers("");
    };

    const activeManagers = filteredManagers.filter(
      (manager) => manager.active === 1
    );

    const inactiveManagers = filteredManagers.filter(
      (manager) => manager.active === 0
    );

    const {
      isOpen: isInactiveOpen,
      onToggle: onInactiveToggle,
    } = useDisclosure();

    const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });

    const onToggleDropdown = () => {
      if (!isOpen && dropdownRef.current) {
        const rect = dropdownRef.current.getBoundingClientRect();

        setDropdownPos({
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
        });
      }

      onToggle();
    };

    return (
      <Box position="relative" width="170px" ref={dropdownRef}>
        <Button
          w="100%"
          borderRadius="10px"
          bg="rgb(51, 51, 51)"
          color="myColor.white"
          fontSize={"12px"}
          _hover={{
            bg: "rgb(27, 26, 26)",
            color: "myColor.green",
          }}
          rightIcon={<Icon as={isOpen ? FiChevronUp : FiChevronDown} />}
          onClick={onToggleDropdown}
          justifyContent="space-between"
        >
          {selectedManagers.length > 0
            ? `Выбрано: ${selectedManagers.length}`
            : "Не выбрано"}
        </Button>
        <Portal>
          <Collapse in={isOpen} animateOpacity>
            <Box
              ref={menuRef}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              mt={2}
              p={4}
              bg="#1e1e1e"
              borderRadius="md"
              boxShadow="lg"
              zIndex="dropdown"
              position="absolute"
              top={`${dropdownPos.top}px`}
              left={`${dropdownPos.left}px`}
              width="600px"
            >
              <InputGroup mb={3}>
                <InputLeftElement pointerEvents="none">
                  <Icon as={FiSearch} color="gray.400" />
                </InputLeftElement>
                <Input
                  placeholder="Поиск менеджеров"
                  value={pageStore.searchTermManagers}
                  onChange={(e) => pageStore.setSearchTermManagers(e.target.value)}
                  color="myColor.white"
                  _placeholder={{ color: "gray.400" }}
                />
              </InputGroup>

              <Box maxH="600px" overflowY="auto" mb={3}>
                <List spacing={2}>
                  <ListItem
                    p={1}
                    borderRadius="md"
                    _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
                  >
                    <Checkbox
                      isChecked={
                        selectedManagers.length > 0 &&
                        filteredManagers.every((manager) =>
                          selectedManagers.includes(manager.fio)
                        )
                      }
                      isIndeterminate={
                        selectedManagers.length > 0 &&
                        !filteredManagers.every((manager) =>
                          selectedManagers.includes(manager.fio)
                        )
                      }
                      onChange={handleSelectAll}
                      colorScheme="blue"
                      color="myColor.white"
                    >
                      <Text as="span" fontWeight="bold">
                        Выбрать все
                      </Text>
                    </Checkbox>
                  </ListItem>

                  {activeManagers.map((manager) => (
                    <ListItem key={manager.fio} p={1}>
                      <Checkbox
                        isChecked={selectedManagers.includes(manager.fio)}
                        onChange={() => handleSelect(manager.fio)}
                        colorScheme="blue"
                        color="myColor.white"
                      >
                        {manager.fio}
                      </Checkbox>
                    </ListItem>
                  ))}
                  {inactiveManagers.length > 0 && (
                    <>
                      <ListItem
                        mt={3}
                        p={1}
                        cursor="pointer"
                        onClick={onInactiveToggle}
                        _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
                      >
                        <Flex align="center" justify="space-between">
                          <Text color="red.400" fontWeight="bold">
                            УВОЛЕННЫЕ ({inactiveManagers.length})
                          </Text>
                          <Icon
                            as={isInactiveOpen ? FiChevronUp : FiChevronDown}
                            color="red.400"
                          />
                        </Flex>
                      </ListItem>

                      <Collapse in={isInactiveOpen} animateOpacity>
                        <List spacing={2} pl={4} mt={2}>
                          {inactiveManagers.map((manager) => (
                            <ListItem key={manager.fio} p={1}>
                              <Checkbox
                                isChecked={selectedManagers.includes(manager.fio)}
                                onChange={() => handleSelect(manager.fio)}
                                colorScheme="red"
                                color="myColor.white"
                              >
                                {manager.fio}
                              </Checkbox>
                            </ListItem>
                          ))}
                        </List>
                      </Collapse>
                    </>
                  )}
                </List>
                <Flex justify="space-between">
                  <Button
                    leftIcon={<Icon as={FiX} />}
                    variant="ghost"
                    color="gray.400"
                    onClick={handleReset}
                  >
                    Сбросить
                  </Button>
                  <Box>
                    <Button
                      bg="rgba(66, 62, 62, 1)"
                      color="myColor.white"
                      _hover={{
                        bg: "rgba(106, 99, 99, 1)",
                        color: "myColor.green",
                      }}
                      onClick={handleSave}
                    >
                      Применить
                    </Button>
                  </Box>
                </Flex>
              </Box>
            </Box>
          </Collapse>
        </Portal>
      </Box>
    );
  });

  export default ModalSelectManagers;